import { createSlice } from '@reduxjs/toolkit';

import { fetchTag } from '../actions/adminSlice';

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    error: null,
    loading: true,
    tag: {}
  },
  extraReducers: builder => {
    builder
      // Fetch Tag by id
      .addCase(fetchTag.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTag.fulfilled, (state, action) => {
        state.tag = action.payload;
        state.loading = false;
      })
      .addCase(fetchTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default adminSlice.reducer;
